<template>
    <div class="pillars">
      <b-container fluid class="mt-5 p-0">
        <b-card no-body v-for="currentPillar in pillars" :key="currentPillar.key">
          <b-card-header header-tag="header" class="p-1 rounded-0" :style="{ 'background-color': currentPillar.color }" role="tab" block>
            <b-button text-variant="white" block squared v-b-toggle="`pillars-acc-${currentPillar.key}`" class="invisibut">{{ currentPillar.description }}</b-button>
          </b-card-header>
          <b-collapse :id="`pillars-acc-${currentPillar.key}`" v-model="currentPillar.active" accordion="pillars-acc" role="tabpanel" :style="{ 'background-color': currentPillar.color }">
            <div class="txt">
              <b-card no-body>
                <b-tabs class="ttxt" card v-model="currentPillar.priorityIndex">
                  <b-tab v-for="currentPriority in currentPillar.priorities" :key="currentPriority.key" :title="currentPriority.title" class="p-0 txt">
                    <b-card no-body v-model="currentPriority.objectiveIndex">
                      <h3 class="font-weight-bold mt-4 mb-4" style="color: #0291ed">{{ currentPriority.description }}</h3>
                      <div align="left" v-for="currentObjective in currentPriority.objectives" :key="currentObjective.key">
                        <h5 class="font-weight-bold margint" align="left" style="color: #0291ed">
                          {{ currentObjective.title }}
                          <span class="desc">{{ currentObjective.description }}</span>
                        </h5>
                      </div>
                    </b-card>
                  </b-tab>
                </b-tabs>
              </b-card>
            </div>
          </b-collapse>
        </b-card>
      </b-container>
    </div>
</template>

<script>
export default {
  name: "Pillars",
  data: () => ({
    pillars: [
      {
        key: "pillar-1",
        description: "What Is The Secure Our Future Referendum #210?",
        color: "#bd5ca3",
        priorityIndex: 0,
        priorities: [
          {
            key: "priority-1",
            title: "",
            description: "",
            objectiveIndex: 0,
            objectives: [
              {
                key: "obj-1",
                title: "•",
                description: "This is a continuation of the “Secure Our Future” Referendum passed in 2018 by voters with over a 70 percent approval of votes cast to improve compensation for teachers and improve school safety.",
              },
              {
                key: "obj-2",
                title: "•",
                description:"Miami-Dade County Public Schools (M-DCPS) will ask county voters to invest in our children and our community once again through the renewal of a referendum on a 1 Mill levy in property taxes for up to the next four (4) years. Charter Schools will share in the revenue raised."
              },
              {
                key: "obj-3",
                title: "•",
                description:"These funds will allow for the continuation of improvements made to the compensation of teachers and instructional personnel as a result of the 2018 referendum which is set to expire June 30, 2023. "
              },
              {
                key: "obj-4",
                title: "•",
                description: "The funds will also continue to be used to improve student safety and school security as it has been since 2018.  ",
              },
              {
                key: "obj-5",
                title: "•",
                description: "This is NOT a new tax. The 2018 tax will end June 30, 2023, and the renewed tax, if passed, will begin July 1, 2023. ",
              },
              {
                key: "obj-6",
                title: "•",
                description: "These dollars will be used for all public-school students, including charter school students. This levy will raise funds for teachers and safety, for an investment of approximately $250 per year for the typical homeowner based on the Save Our Homes valuation, or approximately $20 per month (just $6 more per month than the current rate), beginning in tax year 2023-2024. ",
              },
              {
                key: "obj-7",
                title: "•",
                description: "M-DCPS’ current tax rate is close to the lowest it has been since the 1970s and will remain so, even with a continuation of the referendum.",
              },
              {
                key: "obj-8",
                title: "•",
                description: "A citizens’ oversight advisory committee will continue to monitor the use of proceeds generated by the renewal of the referendum to safeguard the taxpayers’ investment.",
              },
            ],
          },
        ],
      },
      {
        key: "pillar-2",
        description: "Why is the Referendum necessary?",
        color: "#1c4096",
        priorities: [
          {
            key: "priority-1",
            title: "",
            description: "",
            objectives: [
              {
                key: "obj-1",
                title: "•",
                description: "M-DCPS is one of the highest-performing urban school systems in the state, and it became an 'A'-rated district as of 2018 and has maintained that rating.",
              },
              {
                key: "obj-2",
                title: "•",
                description: "M-DCPS continues to outperform other Florida school districts and the state even as our students recover from COVID learning loss.",
              },
              {
                key: "obj-3",
                title: "•",
                description: "M-DCPS’ graduation rates have risen to over 90 percent. This remarkable performance is largely the result of the outstanding work of M-DCPS teachers.",
              },
              {
                key: "obj-4",
                title: "•",
                description: "Attracting committed, talented people to the teaching profession requires that they see a promising financial future in the profession and can afford to live in the community they serve.",
              },
              {
                key: "obj-5",
                title: "•",
                description: "Nationally, Florida ranks near the bottom (48th) in the average salary for instructional staff.",
              },
              {
                key: "obj-6",
                title: "•",
                description: "Teachers find it increasingly difficult to afford median housing costs in Miami-Dade County; the home price index for this metro region has risen steadily including a 50 percent increase since the first Secure Our Future vote.",
              },
              {
                key: "obj-7",
                title: "•",
                description: "Miami-Dade County has one the highest costs of living for any Florida county.",
              },
              {
                key: "obj-8",
                title: "•",
                description: "M-DCPS provides a law enforcement officer at every school site from bell to bell and is able to do so without impacting educational programs because of the referendum funding.",
              },
            ],
          },
        ],
      },
      {
        key: "pillar-3",
        description: "Why is the Referendum being put on the ballot this November?",
        color: "#0073b0",
        priorities: [
          {
            key: "priority-1",
            title: "",
            description: "",
            objectives: [
              {
                key: "obj-1",
                title: "•",
                description: "The existing “Secure Our Future” levy which was passed by voter approved referendum in 2018 will expire June 30, 2023.",
              },
              {
                key: "obj-2",
                title: "•",
                description: "This type of operational millage levy may only by authorized for four (4) years at a time.  In order to ensure that the improvements to teacher compensation and school safety can be maintained, the Board must once again put the referendum before the voters for their approval. ",
              },
              {
                key: "obj-3",
                title: "•",
                description: "If passed, the continuation levy will be in place beginning July 1, 2023 through June 30, 2027.",
              },
              {
                key: "obj-4",
                title: "•",
                description: "Charter Schools will now be included in the referendum. All students who attend a public school will benefit.",
              },
            ],
          },
        ],
      },
      {
        key: "pillar-4",
        description: "How does this issue affect the community?",
        color: "#5eccf5",
        priorities: [
          {
            key: "priority-1",
            title: "",
            description: "",
            objectives: [
              {
                key: "obj-1",
                title: "•",
                description: "By improving compensation for teachers and police we are investing in people who educate and protect our children and who will in turn invest in our local economy.   This is an investment in people, not things.",
              },
              {
                key: "obj-2",
                title: "•",
                description: "The public education system is a vital part of community infrastructure for all residents and taxpayers, even those without family members who presently attend or will soon enter K-12. The education, safety, and financial success of a community’s children as they grow into adults impact the entire community."
              },
              {
                key: "obj-3",
                title: "•",
                description: "School quality affects property values for all homeowners and businesses. Decades of research show “very powerful evidence” that schools and communities are closely intertwined, with increased academic scores linked to a corresponding rise in property values and economic growth.",
              },
              {
                key: "obj-4",
                title: "•",
                description: "K-12 outcomes also improve broader community impacts like crime. Researchers link increases in a community’s education level to significant decreases in major crimes. Miami-Dade’s countywide graduation rate has risen from 80.7% before the first Secure Our Future vote to 90.1% in 2020-21.",
              },
              {
                key: "obj-5",
                title: "•",
                description: "Higher-performing teachers produce a future workforce that is highly skilled and knowledgeable.",
              },
              {
                key: "obj-6",
                title: "•",
                description: "Research generally links school quality to local economic growth. More directly, providing better compensation to teachers and police officers is a positive return on investment for the community and local business owners, as increased buying power through the local economy supports home sales and rentals, automobile sales, and other purchased goods and services from the local economy.",
              },
            ],
          },
        ],
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.pillars ::v-deep .test {
  flex: 1;

  width: 100%;

  .carousel-inner {
    height: 50%;

    .carousel-item {
      height: 100%;
    }
  }
}
.todol {
  align-content: left;
}
.ttxt {
  font-size: 1vw;
  font-style: bold;
}
.invisibut {
  font-size: 1.5vw;
}
.margint {
  margin-left: 5vw;
  margin-top: 1vw;
  margin-bottom: 1vw;
}
.txt {
  margin: auto;
  margin-bottom: 0.25vw;
}
@media screen and (max-width: 1000px) {
  .invisibut {
    font-size: 25px;
  }

  .ttxt {
    font-size: 20px;
  }
}

.desc {
  color: rgb(122, 122, 122);
}
</style>